<template>
  <Transition>
    <Header v-show="isShow" class="Header" :platform="isTopPage ? 'common' : 'sell'" :home="home">
      <ClientOnly>
        <nav class="nav">
          <NuxtLink v-if="isSignedIn" class="navItem" :to="myPageLink">
            <Person/>
            <div class="navLabel">マイページ</div>
          </NuxtLink>
          <NuxtLink v-else :to="signinLink">
            <Button :platform="isTopPage ? 'common' : 'sell'" size="x-sm" mode="secondary" text="ログイン"/>
          </NuxtLink>
          <Cart
            v-if="mode === 'default'"
            platform="sell"
            :quantity="totalOrderNum"
            :price="merchandiseAmount"
            @click="cartState.showCart.value = true"
          />
        </nav>
      </ClientOnly>
    </Header>
  </Transition>
</template>

<script lang="ts">
import { defineNuxtComponent, useNuxtApp, useRouter } from '#imports'
import { computed, onMounted, onBeforeUnmount } from 'vue'
import { DITokens } from '@/di'
import { storeToRefs } from 'pinia'
import { Header, Button, Cart } from '@ka-nabellinc/ka-nabell-ui'
import { Person } from '@ka-nabellinc/ka-nabell-icons'
import { useProfileWeb } from '@/composables/useProfileWeb'

const BORDER_POSITION = 200

export default defineNuxtComponent({
  components: {
    Header,
    Person,
    Cart,
    Button
  },
  props: {
    mode: {
      type: String as () => 'default' | 'simple',
      default: 'default'
    }
  },
  setup() {
    const { $container } = useNuxtApp()
    const profileStore = $container.resolve(DITokens.ProfileStore)
    const profileState = storeToRefs(profileStore)
    const cartStore = $container.resolve(DITokens.CartStore)
    const cartState = storeToRefs(cartStore)
    const router = useRouter()

    const isShow = ref(true)
    const scrollTop = ref(0)

    const totalOrderNum = computed(() => {
      if (router.currentRoute.value.meta.genre === 'pokemon') {
        return cartState.pokemonCartTotalOrderNum.value
      }
      return 0
    })
    const merchandiseAmount = computed(() => {
      if (router.currentRoute.value.meta.genre === 'pokemon') {
        return cartState.pokemonCartMerchandiseAmount.value
      }
      return 0
    })
    const isTopPage = computed(() => router.currentRoute.value.path === '/')
    const home = computed(() => router.currentRoute.value.meta.genre === 'pokemon' ? '/pokemon' : '/')

    const {
      myPageLink,
      signinLink
    } = useProfileWeb()

    const handleScroll = () => {
      const isScrollDown = scrollTop.value < document.documentElement.scrollTop

      if (isScrollDown && scrollTop.value > BORDER_POSITION) {
        isShow.value = false
      } else {
        isShow.value = true
      }
      scrollTop.value = document.documentElement.scrollTop
    }

    onMounted(() => {
      window.addEventListener('scroll', handleScroll)
    })

    onBeforeUnmount(() => {
      window.removeEventListener('scroll', handleScroll)
    })

    return {
      cartState,
      isSignedIn: profileState.isSignedIn,
      signinLink,
      myPageLink,
      totalOrderNum,
      merchandiseAmount,
      isTopPage,
      home,
      isShow,
      scrollTop
    }
  }
})
</script>

<style scoped>
.Header {
  box-sizing: border-box;
  position: fixed;
  top: 0;
  z-index: 100; /* TODO: 変数化してサイト全体で重ね順不備が起きないようにする */
}

.nav {
  height: 100%;
  display: flex;
  align-items: center
}

.navItem {
  height: 100%;
  padding: 4px 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  cursor: pointer;
}

.navLabel {
  font-size: 9px;
  line-height: 120%;
}

.v-enter-active {
  animation: enter 0.5s ease;
}

.v-leave-active {
  animation: leave 0.5s ease;
}

@keyframes enter {
  0% {
    transform: translateY(-30px);
    opacity: 0;
  }
  
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
  
@keyframes leave {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  
  100% {
    transform: translateY(-30px);
    opacity: 0;
  }
}
</style>